import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import RichTextEditor from 'react-rte';
import ReactQuill from 'react-quill';
import storage from "../../../../firebaseConfig.js"
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import LinearProgress from '@material-ui/core/LinearProgress';

import 'react-quill/dist/quill.snow.css';
import {
  Button,
  Avatar,

  TextField,
  Paper,
  Typography,
  Grid,
  FormHelperText,
  Switch
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Box from '@material-ui/core/Box';
import { CameraAlt, PictureAsPdf } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
    marginTop: theme.spacing(2),
    textAlign: 'center'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  descriptionfield: {
    width: '100%',
    height: 200,
    marginBottom: 8
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {

    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  input: {
    display: 'none',
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));
function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}
const NewsDetails = props => {
  const { open, onClose, onSave, usercontent, masters, viewtype, className, isEdit, ...rest } = props;

  const classes = useStyles();

  const initialValues = {
    languages: ['All', 'Tamil', 'English', 'Telugu'],
    issame : true,
    imageurl: '',
    commodity: [],
    language: []
  };
  const [percent, setPercent] = React.useState(0);
  const [masterlanguages, setMasterLanguages] = React.useState([]);
  const [mastercommodities, setMastercommodities] = React.useState([]);
  const [selectedlangs, setSelectedlangs] = React.useState([]);

  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [values, setValues] = useState({ ...initialValues });
  const [value, setValue] = useState('');
  const [error, setError] = React.useState({error: false,
    message: {
      
    }});
    const toggleChecked = (type) => e => {
      setValues({
        ...values,
        "issame" : e.target.checked
      });
    };
      const togglepush = (type) => e => {
        setValues({
          ...values,
          "isPush" : e.target.checked
        });
   
  };
  const handleEditorChange = type => (html) => {

    if (type == 'nameAll' || type == 'descAll') {
      let keyname = type == 'nameAll' ? 'name' : 'desc'

      let updatevalues = {}
      masters.languages.map((order, index) => {
        updatevalues[keyname + order.name] = html

      })

      setValues({
        ...values,
        ...updatevalues
      });

    } else {
      if(type == 'descsame')
      {
        let updatevalues = {}
        selectedlangs.map((order, index) => {
  
          updatevalues["desc" + order.name] = html
  
        })
  
        updatevalues[type] = html

        
        setValues({
          ...values,
          ...updatevalues
        });
      }else{
      setValues(values => ({
        ...values,
        [type]: html
      }));
    }
    }
  }
  const setData = async (value, name, fun, state) => {

    let url = null;
    let extra = {};
    if (name === "imageurl" || name === "pdfurl") {
      if (!value) {
        alert("Please choose a file first!")
      }

      const storageRef = ref(storage, `/update/${value.name}`)
      const uploadTask = uploadBytesResumable(storageRef, value);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );

          // update progress
          setPercent(percent);
        },
        (err) => console.log(err),
        () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            let url_array = []
            if(name === "imageurl")
            {
              if(values.imageurl.length > 0)
              {
                url = values.imageurl +"|"+url
              }
              url_array = url.split("|")
            }
            
            if(name === "imageurl")
            {
              setValues(values => ({
                ...values,
                [name]: url,
                ["imageurl_arr"] : url_array
              }));
            }else
            {
              setValues(values => ({
                ...values,
                [name]: url
              }));
            }
           
          });
        }
      );

    }

    fun({
      ...state, [name]: value, ...extra
    })
  }
  const handleClear = () => {
    setValues({ ...initialValues });
  };


  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };
  const handleinputchange = type => e => {
    if (type == 'nameAll' || type == 'descAll') {
      let keyname = type == 'nameAll' ? 'name' : 'desc'
      let updatevalues = {}
      masters.languages.map((order, index) => {

        updatevalues[keyname + order.name] = e.target.value

      })


      
      setValues({
        ...values,
        ...updatevalues
      });

    } else {
      if(type == 'namesame')
      {
        let updatevalues = {}
        selectedlangs.map((order, index) => {
  
          updatevalues["name" + order.name] = e.target.value
  
        })
        updatevalues[type] = e.target.value

        
        setValues({
          ...values,
          ...updatevalues
        });
      }
      else  if(type == 'descsame')
      {
        let updatevalues = {}
        selectedlangs.map((order, index) => {
  
          updatevalues["desc" + order.name] = e.target.value
  
        })
        updatevalues[type] = e.target.value

        
        setValues({
          ...values,
          ...updatevalues
        });
      }
      else
      {
        if(type === "imageurl")
        {
          let url = e.target.value;
          let url_array = url.split("|")
          setValues(values => ({
            ...values,
            [type]: url,
            ["imageurl_arr"] : url_array
          }));
        }else{
        setValues({
          ...values,
          [type]: e.target.value
        });
      }
    }
      
    }
  }
  const handleTagAdd = () => {
    setValues(values => {
      const newValues = { ...values };

      if (newValues.tag && !newValues.tags.includes(newValues.tag)) {
        newValues.tags = [...newValues.tags];
        newValues.tags.push(newValues.tag);
      }

      newValues.tag = '';

      return newValues;
    });
  };

  const handleTagDelete = tag => {
    setValues(values => {
      const newValues = { ...values };

      newValues.tags = newValues.tags.filter(t => t !== tag);

      return newValues;
    });
  };

  const handleToggleProject = () => {
    setExpandProject(expandProject => !expandProject);
  };

  React.useEffect(() => {
    if(masters.commodity)
    {
      setMastercommodities([
        ...masters.commodity
      ])
      if(isEdit)
      {
        masters['commodity'] = [
       
          ...masters.commodity
        ]
      }else {
        masters['commodity'] = [
          {
            id: 0,
            name : "All"
          },
          ...masters.commodity
        ]
      }
      
    }
    if(masters.languages)
    {
      let langs_arr = [...masters.languages]
      langs_arr.splice(0,1)
      setMasterLanguages([
        ...langs_arr
      ])
      if(isEdit)
      {
        masters['languages'] = [
          ...langs_arr
        ]
      
      }
    }
   },[masters]);
  const handleToggleCustomer = () => {
    setExpandCustomer(expandCustomer => !expandCustomer);
  };
  const handleoptionchange = type => (event, value) => {
    if(type === 'language' && value.length > 0 && value[0].name === 'All')
    {
      let langs = [];

      masters.languages.map((element)=> {
        if(element.name != 'All')
        {
          langs.push(element)

        }
      })
      setSelectedlangs([...langs])
      masters['languages'] = [
        {
          id : 0,
          name : "All"
        }
      ]

      setValues(values => ({
        ...values,
        [type]: value
      }));
    
    }else {
    if(type === 'language')
    {
      if(value.length > 0)
      {
        setSelectedlangs([...value])

        masters['languages'] = [
          ...masterlanguages
        ]
      }else{
        masters['languages'] = [
          {
            id : 0,
            name : "All"
          },
          ...masterlanguages
        ]
        setSelectedlangs([])
      }
    }
  
    if(type == 'commodity')
    {
      if(value.length > 0)
      {
        if(value[0].name == "All")
        {
          masters['commodity'] = [...value]
        }else{
        masters['commodity'] = [
          ...mastercommodities
        ]
      }
      }else{
        masters['commodity'] = [
          {
            id : 0,
            name : "All"
          },
          ...mastercommodities
        ]
      }
    }

    setValues(values => ({
      ...values,
      [type]: value
    }));
  }
  }
  const handleSubmit = event => {
    event.preventDefault();
    let iserror = false
    let messagecontent = {}
    if(!values.language || values.language.length == 0)
    {
      iserror = true
      messagecontent['language'] = "Please enter choose atleast one language"
    }else{
      let langs =  [
        ...selectedlangs
      ]
    
      if(values.language.length == 1)
      {
        if(values.language[0].name === 'All')
        {
          langs = [
            ...selectedlangs
          ]

      // langs.splice(0,1)
        }
      }
      langs.map((element,index) => {
        if(!values.issame)
        {
        if(!values['name'+element.name])
        {
          iserror = true
         messagecontent['name'+element.name] = `Please enter ${element.name} title`
        }

        if(!values['desc'+element.name])
        {
          iserror = true
         messagecontent['desc'+element.name] = `Please enter ${element.name} description`
        }
      }else{
        if(!values['descsame'])
        {
          iserror = true
          messagecontent['descsame'] = "Please enter  description";
        }
        if(!values['namesame'])
        {
          iserror = true
         messagecontent['namesame'] = "Please enter  title";
        }
      }
      })
    }
    if(!values.commodity || values.commodity.length == 0)
    {
      iserror = true
      messagecontent['commodity'] = "Please enter choose atleast one commodity"
    }else{

      if(values.commodity.length == 1 && values.commodity[0].name == "All")
       {
          values['commodity'] = [...mastercommodities];
       }
    }
    if(!values.imageurl || values.imageurl.length == 0)
    {
      iserror = true
      messagecontent['imageurl'] = "Please add image"
    }
    values['languages'] = masterlanguages

    if(iserror)
    {

    let errorcontent = {
      error : true,
      message : messagecontent
    }

    setError(errorcontent)
  }else{
    let errorcontent = {
      error : false,
      message : messagecontent
    }
    setError(errorcontent)
   onSave && onSave(values);
   debugger;
  }
   // 
  };
  React.useEffect(() => {
    if (usercontent && usercontent.id) {
      if (usercontent && usercontent.id) {
        
      let  url_array = usercontent?.imageurl.split("|")
        setSelectedlangs(usercontent.language)
        setValues({
          ...usercontent,
          imageurl_arr : url_array,
          issame : false
        })
        
      }

    }
  }, [usercontent]);
  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];

  return (
    <Paper className={classes.papercontent}>
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >

        <div className={classes.content}>
          <Grid container row xs={12} spacing={2}>
            <Grid container xs={9} spacing={2}>
              <Grid item xs={12}>
                {masters.languages && <Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={masters?.languages??[]}
                  margin="dense"
                  fullWidth
                  value={values?.language??[]}
                  defaultValue={values?.language}
                  onChange={handleoptionchange('language')}
                  getOptionSelected={(option, value) => option.name === value.name}
                  filterSelectedOptions
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} 
                  error={error?.message?.language}
                  helperText={error?.message?.language}
                  label={"Languages"} fullWidth margin="dense" variant="outlined" />}
                />}
              </Grid>
              {!values.id && <Grid container row item xs={12} >
                      <Typography variant="body1"> Content same for all language</Typography>
                       <Switch
                            checked={values.issame}
                             onChange={toggleChecked("issame")}
                            color="primary"
                            name="checkedA"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                          />
              </Grid>}
              
              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={masters?.commodity}
                  margin="dense"
                  fullWidth
                  value={values?.commodity}
                  onChange={handleoptionchange('commodity')}
                  getOptionLabel={(option) => option?.name}
                  getOptionSelected={(option, value) => option.name === value.name}
                  renderInput={(params) => <TextField {...params} 
                  error={error?.message?.commodity}
                  helperText={error?.message?.commodity}
                  label={"Commodity"} fullWidth margin="dense" variant="outlined" />}
                />
              </Grid>
             
              {values.issame && selectedlangs.length  > 0 ? 
                 <Grid  container item xs={12} spacing={1}>  
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      autoComplete="off"
                      id="vendordeliverydays"
                      name="vendordeliverydays"
                      value={values['name' + "same"]}
                      error={error?.message['name'+"same"]}
                      helperText={error?.message['name'+"same"]}
                      onChange={handleinputchange('name' + "same")}
                      label={"Title " + "" + "*"}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {/* <ReactQuill className={classes.descriptionfield}
                      theme="snow" value={values['desc' + "same"]} 
                      error={error?.message['desc'+"same"]}
                      helperText={error?.message['desc'+"same"]}
                      onChange={handleEditorChange('desc' + "same")} /> */}

                                      <TextField
                                              variant="outlined"
                                              margin="dense"
                                              multiline
                                              rows={10}
                                              rowsMax={10}
                                              fullWidth
                                              autoComplete="off"
                                              id="vendordeliverydays"
                                              name="vendordeliverydays"
                                              value={values['desc' + "same"]}
                                              error={error?.message['desc'+"same"]}
                                              helperText={error?.message['desc'+"same"]}
                                              onChange={handleinputchange('desc' + "same")}
                                              label={"Title " + "" + "*"}
                                            />
                         {error?.message['desc'+"same"] &&  <FormControl error variant="standard">
                            <FormHelperText id="component-error-text">{error?.message['desc'+"same"]}</FormHelperText> </FormControl> }

                  </Grid> 
                  </Grid> :  
                    
                    <>{selectedlangs != null && selectedlangs.map((order, index) => (
                     
                     <Grid container item marginTop={2} xs={12}> 
                     <Grid item xs={12}>
                        <TextField
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          autoComplete="off"
                          id="vendordeliverydays"
                          name="vendordeliverydays"
                          value={values['name' + order.name]}
                          onChange={handleinputchange('name' + order.name)}
                          error={error?.message['name'+order.name]}
                          helperText={error?.message['name'+order.name]}
                          InputLabelProps={{ shrink: values['name' + order.name] }}
                          label={"Title (" + order.name + "*)"}
                        />
                      </Grid>
                        <Grid item xs={12}>

                        <TextField
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          multiline
                          rows={10}
                          rowsMax={10}
                          autoComplete="off"
                          id="vendordeliverydays"
                          name="vendordeliverydays"
                          value={values['desc' + order.name]}
                          onChange={handleinputchange('desc' + order.name)}
                          error={error?.message['desc'+order.name]}
                          helperText={error?.message['desc'+order.name]}
                          InputLabelProps={{ shrink: values['desc' + order.name] }}
                          label={"DEsc (" + order.name + "*)"}
                        />
                          {/* <ReactQuill 
                            className={classes.descriptionfield}
                            theme="snow" value={values['desc' + order.name]} 
                            error={error?.message['desc'+order.name]}
                            helperText={error?.message['desc'+order.name]}
                            onChange={handleEditorChange('desc' + order.name)} /> */}
                            
                            {error?.message['desc'+order.name] &&  <FormControl error variant="standard">
                            <FormHelperText id="component-error-text">{error?.message['desc'+order.name]}</FormHelperText> </FormControl> }
                        </Grid> </Grid>))}
                        </>
              }
             
              
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  autoComplete="off"
                  id="vendordeliverydays"
                  name="vendordeliverydays"
                  label="Image Url"
                  
                  error={error?.message['imageurl']}
                  helperText={error?.message['imageurl']}
                  value={values.imageurl}
                  onChange={handleinputchange('imageurl')}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  autoComplete="off"
                  id="vendordeliverydays"
                  name="vendordeliverydays"
                  label="Pdf Url"
                  
                  error={error?.message['pdfurl']}
                  helperText={error?.message['pdfurl']}
                  value={values.pdfurl}
                  onChange={handleinputchange('pdfurl')}
                />
              </Grid>

            </Grid>


            <Grid container xs={3} spacing={2}>
             
              <Grid
                container
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
              >
                 {values.imageurl_arr &&  values?.imageurl_arr?.map((element) => (
                  
                <Grid  item margin={2}>
                 <label htmlFor="icon-button-file">
                    <Avatar src={element} style={{ width: 80, height: 80,  marginLeft: 16, borderRadius: 10, cursor: "pointer" }} />
                  </label> 
                  </Grid>))}
                  <Grid item margin={2}>
                  <input accept="image/*" className={classes.input} id="icon-button-file" type="file"
                    onChange={e => setData(e.target.files[0], "imageurl", setValues, values)}
                  />
                 <label htmlFor="icon-button-file" >
                    <Avatar src={""} style={{ width: 80, height: 80, borderRadius: 10, marginLeft: 16,cursor: "pointer" }} >

                    <CameraAlt />
                    </Avatar>
                  </label>
                  </Grid>
                 <Grid item margin={2}>
                  <input accept="*" className={classes.input} id="icon-button-file1" type="file"
                    onChange={e => setData(e.target.files[0], "pdfurl", setValues, values)}
                  />
                  {values.pdfurl ? <label htmlFor="icon-button-file1">
                    <Avatar  style={{ width: 80, height: 80, borderRadius: 10, cursor: "pointer" }} >
                      <PictureAsPdf />
                    </Avatar>
                  </label> : <label htmlFor="icon-button-file1">
                    <Avatar  style={{ width: 80, height: 80, borderRadius: 10, cursor: "pointer" }} >
                    <PictureAsPdf />
                      </Avatar>
                  </label>}

                </Grid> 
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div className={classes.actions}>
                      <Typography variant="body1"> Content same for all language</Typography>
                       <Switch
                            checked={values.isPush}
                             onChange={togglepush("isPush")}
                            color="primary"
                            name="checkedA"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                          />
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            Save
          </Button>
        </div>
      </form>
    </Paper>
  );
};

NewsDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default NewsDetails;
